import { LinkItem } from '@occc/ui-design-system';
import { LocationGroupFragment } from '@occc/graphql';

import { routeCreator } from '../utils';

export const getBreadcrumbLinks = (locationGroup?: LocationGroupFragment): LinkItem[] => {
  if (!locationGroup) {
    return [];
  }

  return [
    {
      to: routeCreator.list(),
      label: 'Site Management',
    },
    {
      key: routeCreator.locationGroupDetails(locationGroup.uuid),
      label: locationGroup.name,
    },
  ];
};
